export default {
  NUM_NATURALES: 1,
  NUM_ORDINALES: 2,
  NUM_FRACCIONES: 3,
  NUM_ROMANOS: 4,
  NUM_DECIMALES: 5,
  NUM_POTENCIAS: 6,
  NUM_PORCENTAJES: 7,
  NUM_ENTEROS: 8,
  NUM_MIXTOS: 9,
  SER_ENTEROS: 10,
  SER_DECIMALES: 11,
  SER_FRACCIONES: 12,
  SER_ORDINALES: 13,
  HECHOSARIT: 14,
  OPERACIONES: 15,
  EQUIVALENCIAS: 16,
  ALG_SUMRESTA: 17,
  ALG_MULTI: 18,
  ALG_SUMTRES: 19,
  ALG_DIVI: 20,
  PRO_SIMPLES: 21,
  PRO_FORMULA: 23,
  PRO_MULTIPLES: 24,
  FICHACONTENIDO: 25,
  TIEMPO: 26,
  TRATINFORMACION: 27,
  GEOPLANO: 28,
  MONEDAS: 29,
  SEXA_SUMRESTA: 30,
  SEXA_MULTDIVI: 31,
  ECU_EQUIVALENCIAS: 32,
  SEXA_CONVER: 33,
  ECU_RESOLUCION: 34,
};
